import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Button, Tooltip } from 'reactstrap';

import { currentCustomerSubscriptionPlanSelector, currentCustomerSubscriptionPlanRawIdSelector, currentUserSelector } from '../../reducers/selectors';

import map from 'lodash/map';
import times from 'lodash/times';
import filter from 'lodash/filter';
import orderBy from 'lodash/orderBy';
import toPairs from 'lodash/toPairs';
import fromPairs from 'lodash/fromPairs';
import indexOf from 'lodash/indexOf';


import {FontAwesomeIcon as FA} from '@fortawesome/react-fontawesome';
import faCheck from '@fortawesome/fontawesome-free-solid/faCheck';
import faMinus from '@fortawesome/fontawesome-free-solid/faMinus';
import faRocket from '@fortawesome/fontawesome-free-solid/faRocket';
import faCaretDown from '@fortawesome/fontawesome-free-solid/faCaretDown';
import faCaretUp from '@fortawesome/fontawesome-free-solid/faCaretUp';
import faInfoCircle from '@fortawesome/fontawesome-free-solid/faInfoCircle';
import classNames from 'classnames';


import faYoutube from '@fortawesome/fontawesome-free-brands/faYoutube';
import { faShopify, faWordpress, faEtsy } from '@fortawesome/free-brands-svg-icons';
import { faRss, faPodcast, faBolt, faClock } from '@fortawesome/free-solid-svg-icons';

//import faWordpress from '@fortawesome/fontawesome-free-brands/faWordpress';
//import faPodcast from '@fortawesome/fontawesome-free-solid/faPodcast';
//import faEtsy from '@fortawesome/fontawesome-free-brands/faEtsy';
//import faRss from '@fortawesome/fontawesome-free-solid/faRss';

import AnnualSwitch from './AnnualSwitch';
import PlanPrice from './PlanPrice';
import plans from './plans';


const mapStateToProps = (state) => ({ 
  currentUser: currentUserSelector(state),
  currentPlan: currentCustomerSubscriptionPlanSelector(state),
  currentPlanRawId: currentCustomerSubscriptionPlanRawIdSelector(state)
});

const matchDispatchToProps = (dispatch) => {
  return bindActionCreators({  }, dispatch)
};

const formatValue = (value) => {
  if (value === true)
    return <FA icon={faCheck} className="icon-true" />
  else if (value === false)
    return <FA icon={faMinus} className="icon-false" />
  else if (typeof value === 'number')
    return value
  else
    return value
} 



const rows = [
  {
    name: "Pages",
    values: [3, 1, 5, 50, 250],
    featured: true,
    tooltip: <div className="text-left">
      <p>Every page you build is a Shor Page.</p>
      <p>You can create a page for everything: for your personal business needs, for giveaways, for music albums, online stores, and even a page to invite your friends to a birthday party!</p>
      <p>There are no limits for your creativity, so the more pages are available for you, the better.</p>
    </div>
  },
  {
    name: "Projects and Teams",
    values: [false, false, false, false, '3+'],
    featured: true,
    tooltip: <div className="text-left">
      <p>Projects can separate pages like folders.</p>
      <p>If you have multiple clients or, for example, two different businesses - projects are must-have for you!</p>
      <p>Once you created several projects, feel free to invite up to 10 team members or clients to help you in managing pages.</p>
    </div>
  },
  
  {
    name: 'Page features',
    subtitle: true,
    values: [],
    cols: 5
  },
  {
    name: <span>Direct messenger buttons</span>,
    values: ['single', true, true, true, true],
    featured: true,
    tooltip: <div className="text-left">
      <p>The faster a visitor finds a way to contact you, the quicker he becomes your client!</p>
      <p>You can set buttons to lead a clicker directly to you from Page to speed up the reach.</p>
      <p>Phone, email, WhatsApp and more - choose the most convenient!</p>
    </div>
  },
  {
    name: <div style={{lineHeight: 1.2}}>Dynamic Feeds<div className="small gray">per page</div></div>,
    values: [false, false, false, 5, 5],
    featured: true
  },
  {
    name: <div style={{lineHeight: 1.2}}>Rich Links<div className="small gray">per page</div></div>,
    values: [2, 50, 10, 50, 500],
    tooltip: <div className="text-left">
      <p>Rich links are the links with images.</p>
      <p>It is highly recommended to use them for adding videos and products to your Page to improve engagement rate!</p>
      <p>The number of Rich Links available per Page depends on a chosen subscription plan.</p>
    </div>
  },
  {
    name: <div style={{lineHeight: 1.2}}><FA icon={faBolt} className="gray" /> Blocks scheduler</div>,
    values: [false, false, false, true, true],
    featured: false
  },
  {
    name: <div style={{lineHeight: 1.2}}><FA icon={faClock} className="gray" /> Countdown timer</div>,
    values: [false, false, false, true, true],
    featured: false
  },
  {
    name: <div style={{lineHeight: 1.2}}>Links<div className="small gray">per page</div></div>,
    values: ['Unlimited', 'Unlimited', 'Unlimited', 'Unlimited', 'Unlimited'],
    tooltip: <div className="text-left">
      <p>Every Page is divided into 3 sections:  Messengers, Blocks, Social Links.</p>
      <p>Everything you add to the Blocks section counts as a link - an image you uploaded from your device or even a text you typed.</p>
      <p>The number of Blocks available to add depends on a subscription plan.</p>
    </div>
  },
  {
    name: <span>Price tags (labels)</span>,
    values: ['single', true, true, true, true],
    featured: false
  },
  
  
  {
    name: <div style={{lineHeight: 1.2}}>Dynamic Feeds</div>,
    subtitle: true,
    values: [],
    cols: 5
  },
  {
    name: <span><FA icon={faYoutube} className="gray" />  Youtube videos</span>,
    values: [false, false, false, true, true]
  },
  {
    name: <span><FA icon={faShopify} className="gray" />  Shopify categories</span>,
    values: [false, false, false, true, true]
  },
  {
    name: <span><FA icon={faWordpress} className="gray" />  Wordpress posts</span>,
    values: [false, false, false, true, true]
  },
  {
    name: <span><FA icon={faPodcast} className="gray" />  Apple Podcasts</span>,
    values: [false, false, false, true, true]
  },
  {
    name: <span><FA icon={faEtsy} className="gray" />  Etsy products</span>,
    values: [false, false, false, true, true]
  },
  {
    name: <span><FA icon={faRss} className="gray" />  Any other RSS/Atom</span>,
    values: [false, false, false, true, true]
  },
  
  
  {
    name: 'Customize',
    subtitle: true,
    values: [],
    cols: 5
  },
  {
    name: "Button image",
    values: [true, true, true, true, true],
    tooltip: <div className="text-left">
      <p>Each button of your Page may include a custom image to add!</p>
      <p>Upload a picture from any place, and choose a way how to display it on your Page.</p>
      <p>It can be placed left to a button title, be a button background, or appear as a big image above the title of your link. </p>
    </div>
  },
  {
    name: "Background image",
    values: [true, true, true, true, true],
    tooltip: <div className="text-left">
      <p>Feel free to choose any image to set as a background for your Page.</p>
      <p>Even a GIF may be added by you to make an eye-catchy page!</p>
    </div>
  },
  {
    name: "Style colors",
    values: [true, true, true, true, true],
    tooltip: <div className="text-left">
      Shor Pages include a huge range of themes to set up: pick a ready-to-go style, choose random colors if you feel lucky, or pick any color to match the design with your brand!
    </div>
  },
  
  {
    name: 'Retention',
    subtitle: true,
    values: [],
    cols: 5
  },
  {
    name: "Ad Platforms (tracking pixels)",
    values: [1, 1, 1, 7, 7],
    tooltip: <div className="text-left">
      <p>Use Facebook, Instagram, Google Ads, Twitter, Pinterest, Quora, LinkedIn, and Snapchat Pixel IDs for integration with Shor to collect audiences and retarget the traffic!</p>
      <p>Choose the preferred platform or use all of them simultaneously by creating Pixel sets.</p>
    </div>
  },
  {
    name: "Tracked Clicks",
    values: ["3k", "10k", "10k", "30k", "1M"],
    tooltip: <div className="text-left">
      <p>Tracked clicks are the human clicks we count to let you see the real statistics for each link or page you have on Shor.</p>
      <p>The number of smart clicks renews every month so that you can get actual statistics monthly and manage your accounts/links according to the data you have.</p>
    </div>
  },
  
  {
    name: 'Short links',
    subtitle: true,
    values: [],
    cols: 5
  },
  {
    name: "Short links",
    values: ['Unlimited', 'Unlimited', 'Unlimited', 'Unlimited', 'Unlimited'],
    tooltip: <div className="text-left">
      <p>You can shorten any link you want to share in the internet using our built-in Shor link shortener.</p>
      <p>Don’t forget to set a pixel into it to collect all of the leads!</p>
    </div>
  },
  {
    name: "Messenger links",
    values: [5, 5, 10, 100, 1000],
    tooltip: <div className="text-left">
      <p>Messenger links are valuable to collect audience - clicker who tried to reach you directly is probably close to becoming your client.</p>
      <p>Put links to preferred ways of contacting you as buttons to the top of your Page, collect and retarget - let your business grow!</p>
    </div>
  },
  {
    name: "Custom slashtags",
    values: [3, 5, 5, 50, 250],
    tooltip: <div className="text-left">
      With custom slashtags, you may turn a generated shor.by/45g3gky link into something good-looking or brand-highlighting, for example, shor.by/niketraining.
    </div>
  },
  
  
  
  {
    name: 'Advanced',
    subtitle: true,
    values: [],
    cols: 5
  },
  {
    name: "Click Insights",
    values: [true,true,true,true,true],
    featured: true,
    tooltip: null && <div className="text-left">
      <p>Our systems count every human click to your links and pages so that you always get the most actual analytics.</p>
      <p>Click insights will show you what link is the most clickable, what contact method your audience prefers, or what social network is being checked more frequently.</p>
      <p>Useful to understand your audience’s behavior!</p>
    </div>
  },
  {
    name: "Google Analytics",
    values: [false,false,false,true,true],
    featured: true,
    tooltip: <div className="text-left">
      <p>The most significant service to analyze and manage your audience is available to integrate with Shor!</p>
      <p>Just put a Google Analytics pixel to all Shor links or pages and collect all of the data you may need.</p>
    </div>
  },
  {
    name: <div style={{lineHeight: 1.2, display: "inline-block"}}>Custom Domain<div className="small gray">per project</div></div>,
    values: [false, false, false, true, true],
    featured: true,
    tooltip: <div className="text-left">
      <p>A custom domain covers shor.by part of a {'Page`s'} address so that the link looks like it’s your website (yoursite.com instead of shor.by).</p>
      <p>Great for big brands! Only 1 custom domain is available to add per a project on Shor.</p>
    </div>
  },
  {
    name: <div style={{lineHeight: 1.2, display: "inline-block"}}>Team members<div className="small gray">per project</div></div>,
    values: [false, false, false, false, 10],
    tooltip: <div className="text-left">
      <p>A team member is someone to help you in managing pages or a client who is craving to see the insights of his Page.</p>
      <p>You can invite a team member to a project so that he/she will only see this exact project without sharing any passwords or credentials.</p>
    </div>
  },
  // {
  //   name: "🔜 Weekly insights",
  //   values: [true,true,true,true,true],
  //   featured: false
  // },
  {
    name: "🤑 Shor Rewards",
    values: [true,true,true,true,true],
    featured: true,
    tooltip: <div className="text-left">
      <p>Shor is famous for its Rewarding program.</p>
      <p>Once you create a Page, you become a part of it and can earn up to $300 from every customer you led doing nothing!</p>
      <p>By the way, you get $30 credits to start from right after the signup.</p>
    </div>
  },
  {
    name: '',
    subtitle: true,
    values: ['','','',
    
    " " ||(<div className="small text-center ">
      <div className="text-center mb1 mt1"><FA icon={faRocket} /> UPGRADE</div>
      <div>$9 for</div>
      <div>30,000 tracked clicks</div>
      <div> </div>
    </div>),
    
    (<div className="small">
      <div className="text-center mb1 mt1"><FA icon={faRocket} /> UPGRADE</div>
      <div>$15/mo 4th-20th project</div>
      <div>$10/mo 21st-100th project</div>
      <div>$7/mo 101st+ project</div>
    </div>)],
    values_annual: ['','','',
    
    " " ||(<div className="small text-center ">
      <div className="text-center mb1 mt1"><FA icon={faRocket} /> UPGRADE</div>
      <div>$9 for</div>
      <div>30,000 tracked clicks</div>
      <div> </div>
    </div>),
    
    (<div className="small">
      <div className="text-center mb1 mt1"><FA icon={faRocket} /> UPGRADE</div>
      <div>$12.5/mo 4th-20th project</div>
      <div>$8.33/mo 21st-100th project</div>
      <div>$5.83/mo 101st+ project</div>
      <div className="text-center">billed annually</div>
    </div>)],
    cols: 5
  },
  
]
let hidden_idxs = map(filter(plans, {hide: true}), 'row_idx');

const SelectPricingButton = connect(mapStateToProps)( ({plan_id, annual, onSuccess, currentPlanRawId, currentPlan}) => {
  
  const corePlanId = plan_id
  const isCurrentPlan = currentPlanRawId === corePlanId;
  
  const CTA = !!currentPlanRawId ? 'Upgrade' : 'Activate'
  
  return (isCurrentPlan ? 
    ( annual && !currentPlan.id.match(/_annual/) ? 
        <Button color="success" outline size="sm" onClick={onSuccess && (() => onSuccess(plan_id))}>Go annual</Button>
      :
        <Button size="sm" outline>Current plan</Button>
    )
  : 
    (
      (!currentPlanRawId || (plans[currentPlanRawId] || {price: 0}).price < plans[corePlanId].price) ? 
        <Button color="primary" size="sm" onClick={onSuccess && (() => onSuccess(plan_id))}>{CTA}</Button>
      : 
      null
    )
  )
})

const PlanName = ({name, description, annual}) => {
  return (
    <div className="plan-name">
      <h2>{name}</h2>
      <div className="plan-description">{description}</div>
    </div>
)}


class FeatureTooltip extends Component{
  
  constructor (props){
    super(props);
    this.toggle = this.toggle.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    
    this.state = {
      isOpen: false
    }
    this.tooltipRef = null;
    this.setTooltipRef = element => {
      this.tooltipRef = element;
    };
  }
  
  toggle () {
    this.setState({isOpen: !this.state.isOpen});
  }

  show (e) {
    const currentTarget = e.currentTarget;
    if (currentTarget === document.activeElement) {
      this.setState({isOpen: true});
    }
  }
  hide (e) {
    const currentTarget = e.currentTarget;
    setTimeout(() => {
      if (!currentTarget.contains(document.activeElement)) {
        this.setState({isOpen: false});
      }
    }, 10);
  }
  
  
  render () {
    const {name, tooltip} = this.props;
    
    return (
      <div>
        <div className="plan-feature-with-tooltip" tabIndex="1" style={{position: 'relative', zIndex: '2'}} ref={this.setTooltipRef} onClick={this.toggle} onBlur={this.hide}><FA icon={faInfoCircle} className="info-icon"/> {name}</div>
        <Tooltip delay={{ show: 100, hide: 100 }} trigger="click" placement="left-start" autohide={false} modifiers={{offset:{offset: '0, 17px', enabled: true}}} isOpen={this.state.isOpen} target={ () => this.tooltipRef}>
          {tooltip}
        </Tooltip>
      </div>
    );
  }
}

const PricingRow = ({name, tooltip, values, values_annual, cols, subtitle, hoverable, nobg, annual}) => {
  const _values = annual === true ? (values_annual || values) : values;
  const colsNum = cols || _values.length;
  let k = 0;
  return (
    <div className={classNames({"pricing-row": true, "flex": true, subtitle, nobg, hoverable: hoverable && !subtitle})}>
      {!subtitle && <div className="pricing-hover"></div>}
      <div className={"pricing-heading col-3 flex"}>
        <div className="flex-auto">
          {!tooltip ? name : <FeatureTooltip {...{name, tooltip}} />}
        </div>
      </div>
      
      {times(colsNum, (i) => ( indexOf(hidden_idxs, i) < 0 &&
        <div key={i} className={`pricing-col pricing-col-${++k} col flex`}>
          <div className="flex items-center justify-center flex-auto">{formatValue(_values[i])}</div>
        </div>
      ))}
    </div>
)}





export class PricingPlanCard extends Component {
  constructor (props){
    super(props)
    this.toggleFeatures = this.toggleFeatures.bind(this)
    this.state = {
      showFeatures: false
    }
  }
  
  toggleFeatures (e) {
    if (e && e.preventDefault)
      e.preventDefault();
    
    this.setState({showFeatures: !this.state.showFeatures})
  }
  
  
  render() {
    const { benefits, row_idx, plan_id, annual, choosePlan } = this.props
    const { showFeatures } = this.state
    const features = filter(rows, (row) => !!row.name && (true || !!row.values[row_idx] || (!!row.name && !!row.subtitle)))
    
    
    return (
      <div className={`pricing-plan-card ${plan_id}-plan`}>
        <PlanName {...this.props} />
        <PlanPrice {...this.props} />
        
        <div className="text-center">
          <SelectPricingButton plan_id={plan_id} annual={annual} onSuccess={choosePlan} />
        </div>
        
        <ul className="pricing-plan-benefits">
          {map(benefits, (benefit, i) => <li key={i}>{benefit}</li>)}
        </ul>
        
        {showFeatures ? <ul className="pricing-plan-features">
          {map(features, (feature, i) => <li key={i} className={classNames({subtitle: feature.subtitle, strikethrough: feature.values[row_idx] === false})}>
            {!feature.subtitle && (feature.values[row_idx] !== true && feature.values[row_idx] !== false) && formatValue(feature.values[row_idx])} {feature.name}
          </li>)}
        </ul> : <span className="toggle-features" onClick={this.toggleFeatures}>All features  <FA icon={faCaretDown} /></span>}
      </div>
    );
  }
}

const PricingCards = connect(mapStateToProps)( ({ plans, annual, toggleAnnual, currentPlanRawId, choosePlan }) => {
  const currentPlanPrice = currentPlanRawId && (plans[currentPlanRawId] || {}).price;
  const plansOrdered = currentPlanPrice ? fromPairs(orderBy(toPairs(plans), [(plan) => Math.sign(plan[1].price - currentPlanPrice)], ['desc'])) : plans
  
  return (
    <div className="pricing-cards container-fluid d-lg-none">
      <div className="text-center">
        <h1>Simple pricing</h1>
        <AnnualSwitch onChange={toggleAnnual} checked={!annual} />
      </div>
      {map(plansOrdered, (plan, plan_id) =>  plan && indexOf(hidden_idxs, plan.row_idx) < 0 && <PricingPlanCard {...plan} plan_id={plan_id} key={plan_id} annual={annual} choosePlan={choosePlan} />)}
      
        
      { <div className="small gray mt1 mb1">Note: all prices in USD all sales are final</div>}
    </div>
  );
})


const FeaturesToggle = ({toggleFeatures, collapseFeatures}) => <span className="toggle-features" onClick={toggleFeatures}>{collapseFeatures ? 'All features' : 'Core features'}  <FA icon={collapseFeatures ? faCaretDown : faCaretUp} /></span>

class Pricing extends Component {
  
  constructor (props){
    super(props)
    
    this.choosePlan = this.choosePlan.bind(this)
    this.toggleAnnual = this.toggleAnnual.bind(this)
    this.toggleFeatures = this.toggleFeatures.bind(this)
    
    this.state = {
      toChoosePlan: false,
      annual: true,
      collapseFeatures: true
    }
  }
  
  componentWillMount (){
    const { currentUser } = this.props
    if (
      (currentUser && indexOf(['imported_lt', 'linktree'], currentUser.ref) >= 0)
      ||
      localStorage.getItem('imported') === '1'
    )
      hidden_idxs = [0, 2];
  }
  
  componentDidMount (){
    this.setToChoosePlan(this.props)
  }
  
  componentWillReceiveProps (nextProps){
    this.setToChoosePlan(nextProps)
  }
  
  setToChoosePlan (props){
    // console.log('props.onSuccess', props.onSuccess)
    this.setState({
      toChoosePlan: props.onSuccess && props.onSuccess instanceof Function
    })
  }
  
  choosePlan (planId){
    if (this.state.toChoosePlan)
      this.props.onSuccess({id: planId, annual: this.state.annual})
  }
  
  
  toggleAnnual () {
    this.setState({annual: !this.state.annual})
  }
  
  toggleFeatures () {
    this.setState({collapseFeatures: !this.state.collapseFeatures})
  }
  
  render() {
    const { annual, collapseFeatures } = this.state;
    const cols_num = filter(plans, (p) => !p.hide).length + hidden_idxs.length;
    
    const UpgradeButtons = <PricingRow name="" cols={cols_num} values={map(plans, (plan, plan_id) => <SelectPricingButton plan_id={plan_id} annual={annual} onSuccess={this.choosePlan} />
)} />   
    
    return (<React.Fragment>
      <div className="pricing-table container-fluid d-none d-lg-block">
        <div className="col-12">
          {<PricingRow annual={annual} nobg={true} name={<h1>Simple pricing</h1>} cols={cols_num} values={map(plans, (plan) => <PlanName {...plan} annual={annual} />)} />}
        </div>
        <div className="col-12">
          <PricingRow annual={annual} name={<AnnualSwitch benefits="true" onChange={this.toggleAnnual} checked={!annual} />} cols={cols_num} values={map(plans, (plan) => <PlanPrice {...plan} annual={annual} />)} />
          {UpgradeButtons}
          {map(collapseFeatures ? filter(rows, 'featured') : rows, (row, k) => <PricingRow annual={annual} hoverable={true} {...row} key={k} />)}
          
          <PricingRow annual={annual} name={<FeaturesToggle toggleFeatures={this.toggleFeatures} collapseFeatures={collapseFeatures} />} cols={cols_num} values={[]} />
          
          {UpgradeButtons}
          <PricingRow annual={annual} name="" values={[]} cols={cols_num} />
        </div>
          
        
      { <div className="small gray mt1 mb1">Note: all prices in USD all sales are final</div>}
      </div>
      
      <PricingCards plans={plans} annual={annual} toggleAnnual={this.toggleAnnual} choosePlan={this.choosePlan} />
        
    </React.Fragment>);
  }
}


export default connect(mapStateToProps, matchDispatchToProps)(Pricing);


// WEBPACK FOOTER //
// ./src/components/billing/pricing.js